import { render, staticRenderFns } from "./Quotationrequests.vue?vue&type=template&id=30754230&"
import script from "./Quotationrequests.vue?vue&type=script&lang=js&"
export * from "./Quotationrequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports